module.exports = __webpack_public_path__ + "static/14-cf4c72f758732a5c6b2b377163f515bb.jpg";